<ng-container *ngIf="currentSettings === settingEnum.MAIN">
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

    <div class="panel-options-body overflow-wrapper">
        <form class="form" (submit)="$event.preventDefault()">
            <div class="form-group mb-20">
                <div>
                    <label>{{ "testimonial_layout_type" | translate }}</label>
                    <a (click)="setCurrentSettingsType(settingEnum.SETTINGS)" class="dotted pull-right">{{
                        "testimonial_settings" | translate
                    }}</a>
                </div>
                <div>
                    <select class="form-control" (change)="setTestimonialLayout($event)">
                        <option
                            *ngFor="let opt of testimonialLayoutOptions"
                            [value]="opt.type"
                            [selected]="layout.value === opt.type"
                        >
                            {{ opt.label | translate }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group mb-20">
                <div>
                    <label>{{ "testimonial_source" | translate }}</label>
                </div>
                <div>
                    <select class="form-control" (change)="setTestimonialCourse($event)">
                        <ng-container *ngIf="(courses$ | async)?.length">
                            <option disabled [ngValue]="null" [selected]="!selectedCourseId.value">
                                {{ "testimonial_choose_course" | translate }}
                            </option>
                            <option
                                *ngFor="let course of courses$ | async"
                                [value]="course.id"
                                [selected]="selectedCourseId.value === course.id"
                            >
                                {{ course.name | translate }}
                            </option>
                        </ng-container>
                        <ng-container *ngIf="!(courses$ | async)?.length">
                            <option disabled [ngValue]="null" [selected]="true">
                                You don't have any active courses
                            </option>
                        </ng-container>
                    </select>
                </div>
            </div>

            <div class="form-group mb-20">
                <div>
                    <label>{{ "testimonial_count" | translate }}</label>
                </div>
                <div>
                    <select class="form-control" (change)="setTestimonialCount($event)">
                        <option
                            *ngFor="let opt of testimonialCountOptions"
                            [value]="opt.type"
                            [selected]="testimonialCount.value === opt.type"
                        >
                            {{ opt.label | translate }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group mb-20" *ngIf="!items.value.length">
                <div class="alert alert-warning">
                    {{ "testimonial_empty_reviews" | translate }}
                </div>
            </div>

            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </form>
    </div>
</ng-container>

<ng-container *ngIf="currentSettings === settingEnum.SETTINGS">
    <web-testimonial-settings
        [itemForm]="settings"
        [testimonialLayout]="layout.value"
        [buttonText]="buttonText.value"
        (setButtonSettings)="setCurrentSettingsType(settingEnum.BUTTON)"
        (cancelEvent)="setCurrentSettingsType(settingEnum.MAIN)"
    ></web-testimonial-settings>
</ng-container>

<ng-container *ngIf="currentSettings === settingEnum.BUTTON">
    <web-testimonial-button-settings
        [itemForm]="buttonSettings"
        (cancelEvent)="setCurrentSettingsType(settingEnum.SETTINGS)"
    ></web-testimonial-button-settings>
</ng-container>
